import { Card, CardContent } from '@/components/ui/card';
import { cn } from 'src/lib/utils';

type Props = {
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  icon: React.ElementType;
  action?: React.ReactNode;
  withCard?: boolean;
  classes?: {
    content?: string;
    card?: string;
    title?: string;
    icon?: string;
    description?: string;
  };
};

const CardWrapper = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <Card className={className}>
      <CardContent className="pt-6">{children}</CardContent>
    </Card>
  );
};

type IContentProps = {
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  icon: React.ElementType;
  action?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  iconClassName?: string;
  descriptionClassName?: string;
};

const Content = ({
  title,
  description,
  icon: Icon,
  action,
  className,
  titleClassName,
  iconClassName,
  descriptionClassName,
}: IContentProps) => (
  <div className={cn('p-6 bg-white rounded-lg border border-dashed border-border text-center', className)}>
    <div
      className={cn(
        'size-13 bg-white rounded-lg border border-border flex items-center justify-center mx-auto shadow-sm mb-4',
        iconClassName,
      )}
    >
      <Icon className="size-5 text-secondary-foreground" />
    </div>
    {title && <h2 className={cn('text-base font-bold text-slate-700 mb-2', titleClassName)}>{title}</h2>}
    {description && (
      <p className={cn('text-sm text-muted-foreground whitespace-pre-wrap', descriptionClassName)}>{description}</p>
    )}
    {action && <div className="mt-6">{action}</div>}
  </div>
);

const EmptyBlock = ({ title, description, icon, action, withCard = true, classes }: Props) => {
  const Icon = icon;

  const content = (
    <Content
      title={title}
      description={description}
      icon={Icon}
      action={action}
      className={classes?.content}
      titleClassName={classes?.title}
      iconClassName={classes?.icon}
      descriptionClassName={classes?.description}
    />
  );

  if (withCard) return <CardWrapper className={classes?.card}>{content}</CardWrapper>;

  return content;
};

export { EmptyBlock };
